module.exports = __webpack_public_path__ + "img/partner_img30.1da7683f.png";